module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "tabindex": "-1",
      "role": "dialog",
      "id": "modalBaixaEstoque"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered"
  }, [_vm._m(1), _vm._v(" "), _c('tbody', _vm._l((_vm.produtos), function(produto, index) {
    return _c('tr', [_c('td', {
      staticClass: "text-left"
    }, [_vm._v(" " + _vm._s(produto.Nome) + " ")]), _vm._v(" "), _c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (produto.QuantidadeUtilizada),
        expression: "produto.QuantidadeUtilizada"
      }],
      staticClass: "form-control",
      attrs: {
        "type": "number",
        "id": "produto",
        "min": "0",
        "placeholder": ""
      },
      domProps: {
        "value": (produto.QuantidadeUtilizada)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(produto, "QuantidadeUtilizada", $event.target.value)
        }
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s((produto.QuantidadeEmEstoque - produto.QuantidadeUtilizada) + '/' + produto.QuantidadeEmEstoque))])])
  }), 0), _vm._v(" "), _vm._m(2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('label', {
    attrs: {
      "for": "atendentes"
    }
  }, [_vm._v("Atendentes")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "multiple": "",
      "value": "Id",
      "label": "Nome",
      "options": _vm.listaAtendentes
    },
    model: {
      value: (_vm.atendentes),
      callback: function($$v) {
        _vm.atendentes = $$v
      },
      expression: "atendentes"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group text-left"
  }, [_c('label', {
    attrs: {
      "for": "observacoes"
    }
  }, [_vm._v("Observações")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.observacoes),
      expression: "observacoes"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "1",
      "id": "observacoes",
      "placeholder": "Digite aqui as observações",
      "maxlength": "100"
    },
    domProps: {
      "value": (_vm.observacoes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.observacoes = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticStyle: {
      "font-style": "italic"
    }
  }, [_vm._v("Caracteres restantes: " + _vm._s(100 - _vm.observacoes.length))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('div', {
    staticClass: "form-group text-right"
  }, [_c('label', {
    attrs: {
      "for": "fichaaprovacao"
    }
  }, [_vm._v("Deseja dar baixa na Ficha de Aprovação?")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.baixaFicha),
      expression: "baixaFicha"
    }],
    attrs: {
      "type": "checkbox",
      "value": "true"
    },
    domProps: {
      "checked": Array.isArray(_vm.baixaFicha) ? _vm._i(_vm.baixaFicha, "true") > -1 : (_vm.baixaFicha)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.baixaFicha,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = "true",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.baixaFicha = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.baixaFicha = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.baixaFicha = $$c
        }
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("Fechar")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button",
      "disabled": _vm.disabledSave
    },
    on: {
      "click": _vm.salvar
    }
  }, [_c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadSave),
      expression: "!loadSave"
    }],
    staticClass: "fa fa-save",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('i', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadSave),
      expression: "loadSave"
    }],
    staticClass: "fa fa-circle-o-notch fa-spin"
  }), _vm._v("  \r\n          Salvar  \r\n        ")])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title text-left"
  }, [_vm._v("Finalizar Atendimento e Baixa no Estoque")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Produto")]), _vm._v(" "), _c('td', [_vm._v("*Quantidade Utilizada")]), _vm._v(" "), _c('td', [_vm._v("Quantidade Em Estoque")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tfoot', [_c('tr', [_c('td', {
    staticStyle: {
      "background": "#2d618e",
      "min-height": "10px",
      "max-height": "10px",
      "font-size": "5px"
    },
    attrs: {
      "colspan": "5"
    }
  }, [_vm._v("   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-79cb3e04"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/shared/atendimento/Finalizar.vue
// module id = 298
// module chunks = 1